<template>
  <iframe
    class="mondays-view-frame"
    src="https://view.monday.com/embed/1897718256-d8731578d55e355106e8c703763c3845?r=use1"
  ></iframe>
</template>

<script>
  export default {
    name: 'Bugs',
  };
</script>

<style scoped>
.mondays-view-frame {
  border: 0;
  box-shadow: 5px 5px 56px 0 rgba(0, 0, 0, 0.25);
  width: 100%;
  height: calc(100vh - 94px);
}
</style>
